import { useCallback, useEffect, useState } from 'react';
import { organizationsApi, OrganizationResponse } from '../../api/organizations';
import { useDebounce } from '../../hooks/useDebounce';

const shapeOrg = (o: OrganizationResponse) => ({
  logoUrl: o.logo_url,
  refId: o.ref_id,
  name: o.name,
  active: o.active,
  settings: o.settings,
  parent: null,
});

export const useClinics = () => {
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [items, setItems] = useState<any[]>([]);

  const debouncedSearch = useDebounce(searchQuery, 250);

  const fetchOrgs = useCallback(async (search?: string) => {
    setLoading(true);
    try {
      const res = await organizationsApi.list();
      const all = res.data.filter((o) => !o.ref_id || o.ref_id.length <= 4).map(shapeOrg);
      const filtered = search
        ? all.filter((o) => o.name?.toLowerCase().includes(search.toLowerCase()))
        : all;
      setItems(filtered);
      return filtered;
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOrgs(debouncedSearch);
  }, [debouncedSearch, fetchOrgs]);

  const pagination = {
    totalNodes: items.length,
    currentPage: 1,
    lastPage: 1,
    nextPage: null,
    perPage: items.length,
    totalPages: 1,
  };

  return {
    loading,
    pagination,
    searchQuery,
    items,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onScroll: () => {},
    onSearch: (q: string) => setSearchQuery(q),
    refetchItems: (_vars?: any) => fetchOrgs(searchQuery),
    setSearchQuery,
  };
};
